import React from "react";

const Tada = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path className="u_fill"
            d="M20.476 25.562 10.425 15.516c-.146-.146-.33-.22-.512-.183a.722.722 0 0 0-.512.22.465.465 0 0 0-.146.219l-7.2 17.205a.711.711 0 0 0 0 .548c.073.183.22.329.365.402a.691.691 0 0 0 .293.073h.146l.036-.036h.074l17.325-7.27c.183-.073.292-.219.365-.402a.585.585 0 0 0-.036-.548.642.642 0 0 0-.147-.182ZM5.052 29.543l1.389 1.389-2.376.986.987-2.375Zm9.796-2.118-2.778 1.132-4.679-4.64 1.133-2.776 6.324 6.284ZM12.764 15.699l-.256.256 1.024 1.022.255-.255c.914-.914 1.536-2.083 1.828-3.361a7.262 7.262 0 0 0-.11-3.544l-.11-.365-1.388.438.11.33c.292.912.292 1.899.109 2.812a5.498 5.498 0 0 1-1.462 2.667Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M12.654 7.735 13.35 10l1.718-1.607 2.303.548-.549-2.302 1.609-1.717-2.266-.694L15.432 2l-1.717 1.607-2.303-.547.548 2.301-1.608 1.717 2.302.657ZM26.544 20.594l-.366-.11a7.275 7.275 0 0 0-3.545-.11c-1.28.293-2.45.914-3.363 1.827l-.256.256 1.023 1.023.256-.256a5.347 5.347 0 0 1 2.669-1.461 5.27 5.27 0 0 1 2.814.11l.329.109.439-1.388Z"
            fill={fill}
        />
        <path className="u_fill"
            d="m34 20.557-2.266-.694-.695-2.265-1.718 1.608-2.302-.548.548 2.301-1.608 1.717 2.266.694.694 2.265 1.718-1.607 2.303.548-.548-2.302L34 20.557ZM22.194 13.8l.695 2.264 1.718-1.607 2.302.547-.548-2.301 1.608-1.717-2.266-.694-.694-2.265-1.718 1.608-2.303-.548.548 2.301-1.608 1.717 2.266.694ZM21.447 15.556l-4.471 4.47-1.008-1.008 4.471-4.469 1.008 1.008Z"
            fill={fill}
        />
    </svg>
);

export default Tada;
